export default __webpack_public_path__ + "static/media/bg.a425b99f.jpg";